// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const DashboardIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor">
      <path
        d="M6.2 21.3h11.6c.62 0 1.19-.23 1.6-.64 1.93-1.92 3.03-4.48 3.1-7.2.13-5.65-4.53-10.57-10.18-10.75-2.87-.08-5.57.97-7.63 2.96-2.06 2-3.19 4.68-3.19 7.54 0 2.82 1.1 5.46 3.1 7.45.4.4 1 .63 1.6.63"
        opacity=".5"
      />
      <path
        fillRule="evenodd"
        d="M14.63 11.77q.37.65.38 1.44c0 1.66-1.35 3.01-3.01 3.01s-3-1.35-3-3c0-1.67 1.34-3.02 3-3.02q.8 0 1.47.39l2.19-2.2c.32-.32.85-.32 1.17 0 .33.33.33.86 0 1.18zm-3.98 1.44c0-.74.6-1.35 1.35-1.35.74 0 1.35.6 1.35 1.35s-.6 1.35-1.35 1.35-1.35-.6-1.35-1.35"
        clipRule="evenodd"
      />
    </g>
  </SvgIcon>
);

export default DashboardIcon;
